export default __webpack_public_path__ + "static/media/usuario.1fc56118.svg";